"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const joi = require("@hapi/joi");
const errors_1 = require("../errors");
exports.validateJoi = (schema = joi.object()) => (payload) => joi.validate(payload, schema, { allowUnknown: true, stripUnknown: true }, (err, value) => {
    if (err) {
        throw new errors_1.ApiClientValidationError(err.message);
    }
    else {
        return value;
    }
});
